import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { EmphasisTextModule } from '@shared/core/components/emphasisText';
import { HeadersModule } from '@shared/core/components/headers';
import { LoadersModule } from '@shared/core/components/loaders';
import { ButtonsModule } from '@shared/core/components/buttons';
import { PickupLabelPipeModule } from '@shared/core/pipes/pickupLabel';

import { OrderInfoComponent } from './order-info.shared.component';
import { InsertVariableToStringModule } from '@shared/core/pipes/insertVariableToString/insert-variable-to-string.pipe.module';

@NgModule({
    declarations: [
        OrderInfoComponent
    ],
    imports: [
        CommonModule,
        EmphasisTextModule,
        HeadersModule,
        LoadersModule,
        PickupLabelPipeModule,
        ButtonsModule,
        InsertVariableToStringModule
    ],
    exports: [
        OrderInfoComponent
    ],
})
export class OrderInfoModule { }
